<template>
    <div class="close-modal">
        <div class="content d-flex justify-content-center align-content-center">
            <h1 class="text-center">
                {{$t('COMMON.confirmQuestion')}} {{confirmationModal.question}}
            </h1>

            <div class="buttons" v-if="confirmationRequired">
                <div class="d-flex justify-content-center"
                     id="buttons-wrapper"
                     @keyup.esc="close" @keyup.enter="confirm">
                    <button type="button" name="no" class="answer" @click="close">
                        {{$t('COMMON.no')}}
                    </button>
                    <button type="button" name="yes" class="answer" ref="buttons"
                            @click="confirm" >
                        {{$t('COMMON.yes')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapMutations } from 'vuex';

export default {
    props: {
        confirmationRequired: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({confirmationModal: 'getConfirmationModal', shouldGoToPrevPage: 'shouldGoToPrevPage'})
    },
    methods: {
        ...mapMutations(['toggleConfirmationModal', 'shouldGoToPrevPageMutation']),
        confirm () {
            this.confirmationModal.callback(true);
            this.$emit('confirm');
            this.close();
        },
        close () {
            this.$emit('close');
            this.shouldGoToPrevPage ? this.$router.go(-1) : null;
            this.shouldGoToPrevPageMutation(true);
            this.toggleConfirmationModal(false);
        }
    },
    mounted () {
        let {buttons} = this.$refs;
        if (buttons) {
            buttons.focus();
        }
    }
};

</script>

<style lang="scss" scoped>
    .close-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
        height: 100%;
        width: 100%;
        z-index: 3000;

        h1 {
            @include color('color', text-color-light);
            line-height: 2em;
        }

        .buttons {
            width: 100%;
        }

        .content {
            width: 100vw;
            height: 100vh;
            flex-wrap: wrap;
        }

        .answer {
            @include color('color', text-color-light);
            margin: 1em;
            font-size: 2em;
            border: 2px solid;
            @include color('border-color', text-color-light);
            background-color: transparent;
            border-radius: 30px;
            padding: 5px 40px;

            &:hover {
                @include color('background-color', background-color-light);
                @include color('color', text-color-dark);
            }

            &:focus {
                outline: none;
            }
        }
    }

    @media screen and (max-width: 768px) {
        #close-modal {
            .answer {
                font-size: 1.5em;
            }

            h1 {
                font-size: 2em;
            }
        }
    }

</style>
